import { Injectable } from '@angular/core';
import { Logger } from './logger.service';

@Injectable({
	providedIn: 'root'
})
export class LocalStorageService {

	private readonly COMPONENT_NAME = "LocalStorageService";
	private readonly orderKey = "persistentOrderSnapshot";

	constructor(private logger: Logger) { }

	isOrderStored(): boolean {
		try {
			return localStorage.getItem(this.orderKey) !== null;
		}
		catch (error) {
			this.logger.error(this.COMPONENT_NAME, "Caught exception in isOrderStored()", error);
			return false;
		}
	}

	saveOrder(orderAsString: string): void {
		localStorage.setItem(this.orderKey, orderAsString);
	}

	loadOrder(): string | null {
		try {
			return localStorage.getItem(this.orderKey);
		}
		catch (error) {
			this.logger.error(this.COMPONENT_NAME, "Caught exception in loadOrder()", error);
			return null;
		}
	}

	clearOrder(): void {
		try {
			localStorage.removeItem(this.orderKey);
		}
		catch (error) {
			this.logger.error(this.COMPONENT_NAME, "Caught exception in clearOrder()", error);
		}
	}

	saveValue(key: string, value: string): void {
		localStorage.setItem(key, value);
	}

	loadValue(key: string): string | undefined {
		return localStorage.getItem(key) || undefined;
	}
}
